var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.033 12.688C18.064 16.0171 20.968 17.1252 21 17.1393C20.9754 17.2173 20.5361 18.7182 19.4703 20.2682C18.5489 21.6084 17.5925 22.9436 16.0862 22.9716C14.6061 22.9985 14.1301 22.0979 12.4377 22.0979C10.7459 22.0979 10.2172 22.9436 8.81592 22.9985C7.3618 23.0534 6.25448 21.5491 5.32545 20.2141C3.42719 17.4827 1.97645 12.4958 3.92436 9.12961C4.89199 7.45793 6.62157 6.39949 8.49866 6.37222C9.92645 6.34513 11.2742 7.32813 12.147 7.32813C13.0192 7.32813 14.657 6.14591 16.3787 6.31945C17.0996 6.34938 19.1227 6.60916 20.4219 8.50184C20.3174 8.56648 18.0079 9.90453 18.033 12.688ZM15.2513 4.51265C16.0232 3.58278 16.5428 2.28794 16.4011 1C15.2883 1.04445 13.9427 1.73791 13.1447 2.66743C12.4293 3.49034 11.803 4.80786 11.9719 6.07029C13.2123 6.16592 14.4792 5.44306 15.2513 4.51265Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7c245c026e6ae4db7e89161366420f89.svg";
export { ForwardRef as ReactComponent };